import React from 'react'

export default function OptionButton(props) {
    return (
        <div className="searchfilter">
            <button className="searchfilter-button searchfilter-option" onClick={props.onClick}>
                <div className="searchfilter-option-icon"><i className="bi bi-sliders"></i></div>
                <span>{props.label}</span>
            </button>
        </div>
    );

}